export const storiesFragment = `
  fragment storiesFragment on StoryListRecord {
    button {
      ...buttonFragment
    }
    headingProps {
      textStyle
    }
    moduleFormat {
      ...moduleFormatFragment
    }
    stories {
      ...storyFragment
    }
    subtitle
    title
  }
`;
